
import { PolicyDecisionConditionCategoryTypes } from "@enums/policy-decision-condition-category-types";
import styles from "./policy-decision-condition-category-cell.less";

type PolicyDecisionConditionCategoryCellProps = {
    category: string;
}
export const PolicyDecisionConditionCategoryCell = (props: PolicyDecisionConditionCategoryCellProps) => {
    const { category } = props;

    const getCategoryLabel = (category: string) => {
        switch (category.toLowerCase()) {
            case PolicyDecisionConditionCategoryTypes.RISK:
                return "Risk";
            case PolicyDecisionConditionCategoryTypes.VERIFICATION:
                return "Verification";
            case PolicyDecisionConditionCategoryTypes.CONTROL:
                return "Control";
            default:
                return "";
        }
    }
    
    const categoryLabel = getCategoryLabel(category);

    return <div className={`${styles.policyDecisionCategory} ${styles[category.toLowerCase()]}`}>
        <span>{categoryLabel}</span>
    </div>
}